/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnseeMessagesResponse
 */
export interface UnseeMessagesResponse {
    /**
     * 
     * @type {number}
     * @memberof UnseeMessagesResponse
     */
    unseeNo?: number | null;
}

export function UnseeMessagesResponseFromJSON(json: any): UnseeMessagesResponse {
    return UnseeMessagesResponseFromJSONTyped(json, false);
}

export function UnseeMessagesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnseeMessagesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unseeNo': !exists(json, 'unseeNo') ? undefined : json['unseeNo'],
    };
}

export function UnseeMessagesResponseToJSON(value?: UnseeMessagesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unseeNo': value.unseeNo,
    };
}


